import { useState } from 'react'

import { useResponsive } from 'hooks'
import { useNavigate } from 'features/i18n/router'

import Modal from 'components/Modal/Modal'

export type WithSettingModalProps = { setTitle: (title: string) => void }

const withSettingModal =
  <T extends WithSettingModalProps>(
    WrappedComponent: (props?: T) => JSX.Element
  ) =>
  (props: Omit<T, 'setTitle'>) => {
    const navigate = useNavigate()
    const { isDesktop } = useResponsive()
    const [title, setTitle] = useState('')

    const _props = {
      ...props,
      setTitle,
    } as T

    if (isDesktop) {
      return (
        <>
          <div className="Box__header">
            <p className="Box__header__h3">{title}</p>
          </div>
          <WrappedComponent {..._props} />
        </>
      )
    }

    return (
      <Modal isActive title={title} onClose={() => navigate(-1)} mode="back">
        <WrappedComponent {..._props} />
      </Modal>
    )
  }

export default withSettingModal
